import React from 'react';
import ReactGA from 'react-ga4';
import './Navbar.css';

const Navbar = ({ activeTab = 'albums', onNavigate, activeAlbumId, isLoading }) => {
  const hasAlbum = Boolean(activeAlbumId) && !isLoading;

  const handleNavigate = (tab) => {
    ReactGA.event({
      category: 'Navigation',
      action: 'Tab Clicked',
      label: tab,
    });
    onNavigate?.(tab);
  };

  return (
    <nav className="navbar navbar-bottom">
      <ul className="navbar-menu">
        <li className="navbar-item">
          <button
            className={`navbar-link ${activeTab === 'figurinhas' ? 'active' : ''} ${!hasAlbum ? 'disabled' : ''}`}
            onClick={() => hasAlbum && handleNavigate('figurinhas')}
            title={hasAlbum ? 'Minhas Figurinhas' : 'Selecione um álbum primeiro'}
            disabled={!hasAlbum}
          >
            Minhas Figurinhas
          </button>
        </li>
        <li className="navbar-item">
          <button
            className={`navbar-link ${activeTab === 'albums' ? 'active' : ''}`}
            onClick={() => handleNavigate('albums')}
            title="Meus Álbuns"
          >
            {isLoading ? <span className="navbar-loading-spinner" /> : 'Meus Álbuns'}
          </button>
        </li>
        <li className="navbar-item">
          <button
            className={`navbar-link ${activeTab === 'faltam' ? 'active' : ''} ${!hasAlbum ? 'disabled' : ''}`}
            onClick={() => hasAlbum && handleNavigate('faltam')}
            title={hasAlbum ? 'Faltam' : 'Selecione um álbum primeiro'}
            disabled={!hasAlbum}
          >
            Faltam
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
